import {SET} from './constants';

const DEFAULT_STATE = {
  openTicketsCount: 0,
};

export default (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case SET: {
      return {
        ...state,
        ...data,
      };
    }

    default: {
      return state;
    }
  }
};
